import gql from 'graphql-tag'

import { fragments as employeeFragments } from '../employees/queries'
import { fragments } from '../customers/queries'

export const insertModeQuery = gql`
	query insertMode {
		calendarInsertMode @client
	}
`

export const calendarDate = gql`
	query date {
		calendarDate @client
	}
`

export const calendarRequirements = gql`
	query calendarRequirements {
		view @client
		calendarZoomLevel @client
		activeLocation @client {
			id
			name
		}
		calendarDate @client
	}
`

export const appointmentFragments = gql`
	fragment appointmentParts on Appointment {
		id
		startTime
		endTime
		price
		duration
		status
		locationId
		createdAt
		customerNote
		employee {
			id
			firstName
			lastName
		}
		services {
			id
			name
		}
		customer {
			...customer
			profile {
				...profile
			}
		}
		source {
			type
		}
	}

	${fragments.customer}
	${fragments.onlineProfile}
`

export const blockedTimeFragments = gql`
	fragment blockedTimeParts on BlockedTime {
		id
		startTime
		endTime
		locationId
		employeeId
		description
	}
`

export const serviceFragments = gql`
	fragment serviceParts on Service {
		id
		name
		sources {
			id
			name
			type
			price
			duration
			serviceId
		}
	}
`

export const locationFragments = gql`
	fragment locationParts on Location {
		id
		name
		employees(input: { where: { bookingEnabled: true } }) {
			...employee

			services {
				...serviceParts
			}
		}

		serviceGroups {
			id
			name
			services {
				...serviceParts
			}
		}

		appointments(
			input: {
				where: {
					status: { notIn: [deleted, canceled] }
					startTime: { gt: $startTime }
					endTime: { lt: $endTime }
				}
			}
		) {
			...appointmentParts
			customer {
				...customer
				profile {
					...profile
				}
			}
		}

		blockedTimes(input: { where: { startTime: { gt: $startTime }, endTime: { lt: $endTime } } }) {
			...blockedTimeParts
		}
	}

	${fragments.customer}
	${fragments.onlineProfile}

	${employeeFragments.employee}
	${appointmentFragments}
	${serviceFragments}
	${blockedTimeFragments}
`

export const calendarResourcesQuery = gql`
	query calendarResources($locationId: ID) {
		activeResource @client {
			...employee
		}

		employees(input: { where: { locationId: $locationId, bookingEnabled: true } }) {
			...employee
		}
	}

	${employeeFragments.employee}
`

export const calendarActiveLocationQuery = gql`
	{
		activeLocation @client {
			id
			name
		}
	}
`

export const CALENDAR_VIEW = gql`
	{
		view @client
	}
`

export const employeeSchedulesQuery = gql`
	query employees($locationId: ID!, $startDate: DateTime!, $endDate: DateTime!) {
		employees(input: { where: { locationId: $locationId, bookingEnabled: true } }) {
			id
			schedule_ranges(
				input: { locationId: $locationId, where: { start_date: $startDate, end_date: $endDate } }
			) {
				day_of_week
				schedule_shifts {
					start_time
					end_time
					acceptingAppointments
					acceptingWalkins
					acceptingCheckins
				}
			}
		}
	}
`

export const calendarInfoQuery = gql`
	query CalendarInfo($locationId: ID!, $startTime: DateTime, $endTime: DateTime) {
		calendarInsertMode @client
		view @client
		timelineInterval @client
		activeAppointment @client
		activeResource @client {
			id
			firstName
		}
		location(locationId: $locationId) {
			...locationParts
			working_hours {
				sunday {
					open
					startTime
					endTime
				}
				monday {
					open
					startTime
					endTime
				}
				tuesday {
					open
					startTime
					endTime
				}
				wednesday {
					open
					startTime
					endTime
				}
				thursday {
					open
					startTime
					endTime
				}
				friday {
					open
					startTime
					endTime
				}
				saturday {
					open
					startTime
					endTime
				}
			}
		}
	}

	${locationFragments}
`
